<template>
  <div class="w-2/3 xl:w-full flex flex-col items-center space-y-5">
    <img src="@/assets/icons/ok-icon.svg" alt="ok">
    <h1 class="text-32px font-bold">{{ $t('landing.questionnaire-sent-successfully') }}</h1>
    <p class="last-screen-text" v-html="$t('landing.online-stage-personal-link-sent-on-your-email', { userEmail })"></p>
    <template v-if="$domain === 'ru'">
      <p v-if="telegramLink" class="last-screen-text" v-html="$t('landing.link-our-telegram-for-more-info')"></p>
      <p v-else class="last-screen-text">
        {{ $t('landing.generating-telegram-link-please-wait')}}
      </p>
      <a
        v-if="telegramLink"
        :href="telegramLink"
        class="flex items-center justify-center w-full h-12 rounded-10px
       bg-neutral-200 text-primary-400 space-x-2 last-screen-text"
        target="_blank"
      >
        <img src="@/assets/icons/telegram_blue.svg" alt="">
        <span>{{ $t('landing.go-to-telegram')}}</span>
      </a>
    </template>
  </div>
</template>
<script>
export default {
  name: 'LastScreen',
  props: {
    telegramLink: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      candidateId: null,
      botNamesMap: new Map([
        ['development', 'smcar_dev_bot'],
      ]),
    };
  },
  async mounted() {
    const candidateToken = JSON.parse(sessionStorage.getItem('candidateToken'));
    this.candidateId = candidateToken?.candidateId;
  },
  computed: {
    userEmail() {
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      return userInfo?.email;
    },
  },
};
</script>
<style>
.last-screen-text {
  max-width: 420px;
}
</style>
